import React from "react";
import { FormControl, MenuItem, Select } from "@mui/material";
import { useTranslation } from "react-i18next";
import { SubmissionType } from "../../types";

export interface Props {
  selected?: SubmissionType;
  onChange: (submissionType: SubmissionType) => void;
  disabled?: boolean;
  /** Override the option list for feature-specific vocabularies — e.g.
   * submission review consolidates Document/Text into "Written submission"
   * while assignments keep the full list. */
  options?: { value: SubmissionType; label: string }[];
}

export const SubmissionTypeSelector = ({
  selected,
  onChange,
  disabled,
  options,
}: Props) => {
  const [t] = useTranslation();

  const submissionTypeOptions = options ?? [
    { value: SubmissionType.Document, label: "Document" },
    { value: SubmissionType.Video, label: "Video" },
    { value: SubmissionType.Text, label: "Text-only submission" },
    { value: SubmissionType.Link, label: "External link" },
    { value: SubmissionType.LivePresentation, label: "Live presentation" },
  ];

  return (
    <FormControl size="small" fullWidth disabled={disabled}>
      <Select
        labelId="submission-type-select-label"
        id="submission-type-select"
        value={selected || SubmissionType.Document}
        onChange={(e) => {
          onChange(e.target.value as SubmissionType);
        }}
      >
        {submissionTypeOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
